module.exports = __webpack_public_path__ + "static/media/01.6be3065b.jpg";